(function () {
    const link = $('.is-tree-view-table').find('.is-has-children');
    link.click(function (e) {
        $(this).closest('.is-tree-list--item--inner').siblings('ul').slideToggle();
        $(this).toggleClass('active');
        e.preventDefault();
    });
})();
